import { render } from "./Disclaimer.vue?vue&type=template&id=7c03e9b0"
import script from "./Disclaimer.vue?vue&type=script&lang=js"
export * from "./Disclaimer.vue?vue&type=script&lang=js"

import "./Disclaimer.vue?vue&type=style&index=0&id=7c03e9b0&lang=scss"
script.render = render

export default script